import React, { useState, useEffect } from "react";
import { NavigationContainer, DefaultTheme } from "@react-navigation/native";
import { View, StyleSheet } from "react-native";
import { SafeAreaProvider } from "react-native-safe-area-context";
import RootNavigator from "./navigation/RootNavigator";
import LoadingIndicator from "./sub/components/LoadingIndicator";
import ErrorMessage from "./sub/components/ErrorMessage";
import InstallPromptWeb from "./components/InstallPromptWeb";
import AppStore from "./storage/appStore";
import { initialUrl, os } from "./platform";
import { COLORS } from "./theme/colors";
import { platform } from "./platform";

// Disable console logs in production mode
if (process.env.NODE_ENV === "production") {
  console.info("Production mode: Disabling console logs");
  console.log = () => {};
  console.error = () => {};
  console.warn = () => {};
}

const LoadScript = platform == "web" ? require("@react-google-maps/api").LoadScript : React.Fragment;

const AppTheme = {
  ...DefaultTheme,
  colors: {
    ...DefaultTheme.colors,
    ...COLORS,
  },
};

const links = {
  prefixes: ["http://localhost:3000/#/", "vbparkfinder://", "https://vbparkfinder.virginiabeach.gov/"],
  config: {
    screens: {
      Parks: {
        screens: {
          ParksMap: "",
          ParkDetails: "details/:park_name",
          ParksList: "list",
          Filter: "filter",
        },
      },
      Trails: "trails",
      Events: "events",
      Contacts: "contacts",
      Settings: "settings",
    },
  },
  ...initialUrl,
};

function App() {
  const loading = AppStore((state) => state.loading);
  const errorMessage = AppStore((state) => state.errorMessage);
  const webInstaller = AppStore((state) => state.webInstaller);

  const [showError, setShowError] = useState(false);

  useEffect(() => {
    setShowError(!loading && errorMessage !== "");
  }, [loading, errorMessage]);

  return (
    <LoadScript {...(platform == "web" ? { googleMapsApiKey: "AIzaSyCbk0Qick_JINm5uspq60xYumyUb3xYQO4" } : {})}>
      <SafeAreaProvider>
        <LoadingIndicator isLoading={loading} />
        <ErrorMessage message={errorMessage} showError={showError} onClose={() => setShowError(false)} />
        <NavigationContainer linking={links} theme={AppTheme}>
          <View style={styles.container}>
            <RootNavigator />
          </View>
        </NavigationContainer>
        {os === "web" && <InstallPromptWeb />}
      </SafeAreaProvider>
    </LoadScript>
  );
}

export default App;

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
});
